module.exports = __webpack_public_path__ + "img/为什么选择背景@3x.3876cb49.png";